module.exports = "/static/images/move.jpg";